const BelarusSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110876)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FCFCFC"
      />
      <path
        d="M8.26082 18.5507L6.08691 14.6067L8.26082 10.7246L10.4347 14.6067L8.26082 18.5507Z"
        fill="#A2001D"
      />
      <path
        d="M3.91316 18.5507L1.73926 14.6067L3.91316 10.7246L6.08707 14.6067L3.91316 18.5507Z"
        fill="#A2001D"
      />
      <path
        d="M8.26082 29.2753L6.08691 25.3313L8.26082 21.4492L10.4347 25.3313L8.26082 29.2753Z"
        fill="#A2001D"
      />
      <path
        d="M3.91316 29.2753L1.73926 25.3313L3.91316 21.4492L6.08707 25.3313L3.91316 29.2753Z"
        fill="#A2001D"
      />
      <path
        d="M10.4348 3.88129L9.81936 2.78223C8.71545 3.43629 7.68006 4.19355 6.72607 5.04074L8.26092 7.8252L10.4348 3.88129Z"
        fill="#A2001D"
      />
      <path
        d="M8.26105 32.1729L6.70996 34.9429C7.66309 35.7911 8.69777 36.5496 9.80121 37.205L10.435 36.055L8.26105 32.1729Z"
        fill="#A2001D"
      />
      <path
        d="M12.1738 25.2168V38.4092C14.5777 39.4324 17.2224 39.9994 19.9999 39.9994C28.5992 39.9994 35.9301 34.5719 38.7559 26.9559L12.1738 25.2168Z"
        fill="#6DA544"
      />
      <path
        d="M38.7559 26.9565C39.5599 24.7898 39.9999 22.4464 39.9999 20C39.9999 8.95437 31.0455 0 19.9999 0C17.2227 0 14.5777 0.566641 12.1738 1.58969V26.9566H38.7559V26.9565Z"
        fill="#A2001D"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110876">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BelarusSvg;
